import React from 'react';

const errorContext = React.createContext({ errorMessage: '', error: () => {} });

export default errorContext;
